/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionterminationdate2Inputs */

const de__field_acquisitionterminationdate2 = /** @type {(inputs: _Field_Acquisitionterminationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akquise-Absagedatum`)
};

/**

* @param {_Field_Acquisitionterminationdate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionterminationdate2 = /** @type {((inputs?: _Field_Acquisitionterminationdate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionterminationdate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionterminationdate2(inputs)
});
export { _field_acquisitionterminationdate2 as "_field_acquisitionTerminationDate" }